<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center w-25" style="gap: 10px">
        <div class="section-title">{{ $tc("refund", 1) }}</div>

        <div class="dropdown-curve-container">
          <div class="d-flex align-items-center">
            <label :class="this.selectedCineId ? 'shift-up' : ''">
              {{ $tc("Cinema") }}
            </label>
            <multiselect
              :key="cinemaIndex"
              select-label="Select"
              label="cine_name"
              :multiple="false"
              :options="cinemasName"
              deselect-label="Remove"
              :clear-on-select="false"
              :close-on-select="true"
              v-debounce:300="searchRefundList"
              placeholder="Search..."
              :show-no-results="true"
              :hide-selected="false"
              track-by="cine_id"
              @select="onSelectCinema($event, cinema.cine_id)"
              @remove="onRemoveCinema($event, cinema.cine_id)"
              v-model="selectedCineIdObj"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <router-link
          v-if="$can('create', 'Refund')"
          variant="default"
          class="btn-blue"
          to="add-refund"
          >{{ $tc("add") }}</router-link
        >

        <div class="d-flex align-items-center">
          <div class="mx-2">
            <b-dropdown name="listview" id="listview" variant="outline-blue">
              <template v-slot:button-content>
                <!-- Viewing&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp; -->
                <strong>{{ viewingRange }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <button
            class="btnj btn-gridView mr-3"
            v-if="GridViewFlag"
            :class="gridView ? 'active' : ''"
            v-on:click="viewType('gridView')"
          ></button>
          <button
            class="btnj btn-listView"
            v-if="GridViewFlag"
            :class="listView ? 'active' : ''"
            v-on:click="viewType('listView')"
          ></button>
        </div>
        Download
        <img
          @click="excelDownload()"
          src="@/assets/img/icons/excel.svg"
          height="25"
          width="25"
        />
      </div>
    </div>

    <div
      class="d-flex justify-content-between align-items-center my-3"
      v-if="false"
    >
      <div class="w-25">
        <div class="dropdown-curve-container" v-if="false">
          <div class="d-flex align-items-center">
            <label :class="this.selectedCineId ? 'shift-up' : ''">
              {{ $t("Select") }}
              {{ $tc("Cinema") }}
            </label>
            <multiselect
              :key="cinemaIndex"
              select-label="Select"
              label="cine_name"
              :multiple="false"
              :options="cinemasName"
              deselect-label="Remove"
              :clear-on-select="false"
              :close-on-select="true"
              v-debounce:300="searchRefundList"
              placeholder="Search..."
              :show-no-results="true"
              :hide-selected="false"
              track-by="cine_id"
              @select="onSelectCinema($event, cinema.cine_id)"
              @remove="onRemoveCinema($event, cinema.cine_id)"
              v-model="selectedCineIdObj"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW -->
    <div class="table-scroll">
      <table class="list-view-table mt-4" v-if="listView">
        <thead>
          <tr>
            <th class="text-center" style="width: 80px">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th style="width: 120px">
              <img
                v-if="this.columnName != 'cine_name'"
                @click="onSortValue('cine_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('cine_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('cine_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("cinema", 1) }}
            </th>
            <th class="text-center" style="width: 80px">
              {{ $tc("screen", 1) }}
            </th>
            <th class="text-center" style="width: 400px">
              <img
                v-if="this.columnName != 'movie_title'"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('movie_title', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('movie_title', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("movie", 1) }}
            </th>
            <th class="text-center" style="width: 110px">
              <img
                v-if="this.columnName != 'ss_start_date'"
                @click="onSortValue('ss_start_date', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('ss_start_date', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('ss_start_date', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("date") }} / {{ $tc("time", 1) }}
            </th>
            <!-- <th class="text-center" style="padding-left:10px"></th> -->
            <th class="text-center" style="width: 100px; padding-left: 20px">
              {{ $tc("transactions", 1) }} {{ $tc("refund_done") }}
            </th>
            <th
              class="text-center"
              style="width: 80px; padding-left: 30px; padding-right: 20px"
            >
              {{ $tc("seats", 1) }} {{ $tc("refund_done") }}
            </th>
            <th class="text-center" style="width: 75px; padding-left: 9px">
              {{ $tc("refund_done", 1) }} {{ $tc("value") }}
            </th>
            <th class="text-center" style="width: 150px">
              {{ $tc("Reason", 1) }}
            </th>
          </tr>
        </thead>
        <tbody v-if="refundList.length > 0">
          <tr
            v-for="(refund, refundIndex) in refundList"
            :key="refundIndex"
            class="light_grey_back"
          >
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="refund.scd_is_active === 'Y' ? 'active' : 'inactive'"
                />
                <span
                  v-if="$can('update', 'Refund')"
                  class="view-icon ml-2 blue-icon"
                  @click="
                    goToRoute('/cinema-manager/show-transaction-refund', refund)
                  "
                  style="cursor: pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </span>
              </div>
            </td>

            <td>{{ refund.cine_name }}</td>
            <td class="text-left">{{ refund.screen_name }}</td>
            <td class="text-left">
              {{ refund.movie_name || refund.movie_title }}
            </td>
            <td class="text-right">
              {{ refund.ss_start_date | dateparse }}
              {{ refund.ss_start_show_time }}
            </td>
            <td class="text-right">{{ refund.no_of_transactions }}</td>
            <td class="text-right">
              {{
                refund.mycinema_booking_type_id == 3
                  ? "Private Booking"
                  : refund.booked_seats
              }}
            </td>
            <td class="text-right">
              {{ refund.total_refund ? refund.total_refund : 0 }}
            </td>
            <td
              class="text-left"
              style="padding-left: 35px; padding-right: 0px"
            >
              {{ refund.scd_reason || "-" }}
            </td>
          </tr>
        </tbody>
        <tbody v-if="refundList.length == 0">
          <tr>
            <td colspan="6">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-if="refundList.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import RefundService from "@/services/RefundService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import MasterService from "@/services/MasterService";
import xlsx from "json-as-xlsx";
import moment from "moment";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      perPageExcel: 100000,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      cinema_id: null,
      refundList: [],
      gridView: false,
      listView: true,
      searchValue: "",
      cinemasName: [],
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      selectedCineId: "",
      selectedCineIdObj: "",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    this.getCinemasList(this.cinema_id);
    this.getRefundList();
    this.getviewingnumber();
    this.getRefundListExcel();
  },
  mounted() {},
  methods: {
    excelDownload() {
      let temp_data = this.refundListExcel;
      let dateparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY")
            : "-";
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY")
            : "-";
      };
      let fulldatemonparse = function (value) {
        if (!value) return "-";
        else if (value === "Invalid date") return "-";
        else if (moment(value, "DD-MM-YYYY HH:mm", true).isValid())
          return value
            ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MMM-YYYY HH:mm")
            : "-";
        else
          return value
            ? moment(value).format("DD-MM-YYYY") === "Invalid date"
              ? "-"
              : moment(value).format("DD-MMM-YYYY HH:mm")
            : "-";
      };

      let data = [
        {
          sheet: "Show Refund",
          columns: [
            {
              value: (row) => (row.cine_name ? row.cine_name : "-"),
              label: "Cinema",
            },
            {
              value: (row) => (row.screen_name ? row.screen_name : "-"),
              label: "Screen",
            },
            {
              value: (row) => (row.movie_name ? row.movie_name : "-"),
              label: "Movie",
            },
            {
              value: (row) =>
                row.ss_start_date
                  ? dateparse(row.ss_start_date) + row.ss_start_show_time
                  : "-",
              label: "Date/Time",
            },
            {
              value: "no_of_transactions",
              label: "Transactions Refunded",
            },
            {
              value: (row) =>
                row.mycinema_booking_type_id == 3
                  ? "Private Booking"
                  : row.booked_seats,
              label: "Seats Refunded",
            },
            {
              value: (row) => (row.total_refund ? row.total_refund : 0),
              label: "Refunded Value",
            },
            {
              value: (row) => (row.scd_reason ? row.scd_reason : "-"),
              label: "Reason",
            },
          ],
          content: temp_data,
        },
      ];
      let settings = {
        fileName: `ShowRefund${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
    onSelectCinema(event, cinema) {
      this.selectedCineId = event.cine_id;
      this.getRefundList();
    },
    onRemoveCinema(event, cinema) {
      this.selectedCineId = "";
      this.getRefundList();
    },
    getCinemasList: function (cine_id) {
      this.cinemasName = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemasName = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getRefundList();
      } else {
        this.currentPage = event;
        this.getRefundList();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getRefundList();
    },
    searchRefundList: function (search) {
      this.getRefundList(1, search);
    },

    getRefundListExcel() {
      let payload = {
        limit: this.perPageExcel,
        currentPage: 1,
        searchValue: "",
        columnName: "",
        orderBy: "",
        cinema_id: this.cinema_id,
        cine_id: this.selectedCineId ? this.selectedCineId : "",
      };

      RefundService.GetAllRefund(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.refundListExcel = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    // Saif
    getRefundList: function (page = undefined, search = undefined) {
      let payload = {
        limit: this.perPage,
        currentPage: page ? page : this.currentPage,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderby,
        cinema_id: this.cinema_id,
        cine_id: this.selectedCineId ? this.selectedCineId : "",
      };

      RefundService.GetAllRefund(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.refundList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show("No Recipes Found");
              this.refundList = [];
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function (path, item) {
      const { ss_id, refund_reason_id } = item;
      console.log("item :", item);
      this.$router.push({
        path: path,
        query: {
          id: ss_id,
          rr_id: refund_reason_id,
        },
      });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RefundComponents/refund.vue